module.exports = "\n<div class=\"footer\">\n  \n</div>"